import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  Alert,
} from "@mui/material";
import {
  Close as CloseIcon,
  Login as LoginIcon,
  PersonAdd as RegisterIcon,
} from "@mui/icons-material";

/**
 * Modal de Login - Muestra mensaje cuando se requiere autenticación
 * @param {boolean} open - Estado de apertura del modal
 * @param {function} onClose - Función para cerrar el modal
 * @param {string} message - Mensaje personalizado (opcional)
 */
const LoginModal = ({
  open,
  onClose,
  message = "Debes iniciar sesión para continuar",
}) => {
  const handleLogin = () => {
    onClose();
    // Redirigir a la página de login o abrir modal de login
    // Por ahora, scroll al navbar donde está el botón de login
    window.scrollTo({ top: 0, behavior: "smooth" });

    // Disparar evento para que el Navbar abra el modal de login
    window.dispatchEvent(new CustomEvent("openNavbarLogin"));
  };

  const handleRegister = () => {
    onClose();
    // Redirigir a la página de registro
    window.scrollTo({ top: 0, behavior: "smooth" });

    // Disparar evento para que el Navbar abra el modal de registro
    window.dispatchEvent(new CustomEvent("openNavbarRegister"));
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <LoginIcon color="primary" />
          <Typography variant="h6" component="span">
            Autenticación Requerida
          </Typography>
        </Box>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ color: "text.secondary" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 3, pb: 2 }}>
        <Alert severity="warning" sx={{ mb: 3 }}>
          {message}
        </Alert>

        <Typography variant="body1" paragraph sx={{ mb: 2 }}>
          Para solicitar cotizaciones y acceder a todas las funcionalidades,
          necesitas tener una cuenta.
        </Typography>

        <Box
          sx={{
            p: 2,
            backgroundColor: "#f5f5f5",
            borderRadius: 1,
            mb: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary" gutterBottom>
            <strong>Beneficios de tener una cuenta:</strong>
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 2 }}>
            <Typography component="li" variant="body2" color="text.secondary">
              Solicitar cotizaciones personalizadas
            </Typography>
            <Typography component="li" variant="body2" color="text.secondary">
              Guardar productos favoritos
            </Typography>
            <Typography component="li" variant="body2" color="text.secondary">
              Historial de cotizaciones
            </Typography>
            <Typography component="li" variant="body2" color="text.secondary">
              Atención prioritaria
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          pt: 2,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          fullWidth
          sx={{ order: { xs: 2, sm: 1 } }}
        >
          Cancelar
        </Button>
        {/* <Button
          onClick={handleRegister}
          variant="outlined"
          color="secondary"
          startIcon={<RegisterIcon />}
          fullWidth
          sx={{ order: { xs: 1, sm: 2 } }}
        >
          Crear Cuenta
        </Button> */}
        <Button
          onClick={handleLogin}
          variant="contained"
          startIcon={<LoginIcon />}
          fullWidth
          sx={{ order: { xs: 0, sm: 3 } }}
        >
          Iniciar Sesión
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LoginModal;
